// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"Loader_lds-ellipsis__4y6Vd","lds-ellipsis1":"Loader_lds-ellipsis1__khLIB","lds-ellipsis2":"Loader_lds-ellipsis2__VzJel","lds-ellipsis3":"Loader_lds-ellipsis3__OWyE3"};